import { render, staticRenderFns } from "./LatestGrid.vue?vue&type=template&id=65fe73bd"
import script from "./LatestGrid.vue?vue&type=script&lang=js"
export * from "./LatestGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports